<div *ngIf="params?.urlIcon; then content else other_content">here is ignored</div>

<ng-template #content>
  <img  [pTooltip]="params.name" tooltipPosition="bottom"  [src]="params.urlIcon" alt="icone da fila">
</ng-template>
<ng-template #other_content>
  <img src="/assets/images/circle_outline.svg" alt="">
</ng-template>
